import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Chats.module.scss';
import { clickTracker } from '../../lib/common';

const OthersIsuue = ({ allIssuesArr, setSelectedSubIssue, setFinalIssuesObj }) => {
  const [searchInput, setSearchInput] = useState('');
  const [filteredData, setFilteredData] = useState(allIssuesArr || {});
  const handleSearchInput = (val) => {
    setSearchInput(val);
    const updatedData = allIssuesArr?.map((issue) => ({
      ...issue,
      filteredDispObj: Object.fromEntries(
        Object.entries(issue.disp_obj).filter(([key]) => key.toLowerCase().includes(val.toLowerCase())),
      ),
    }));
    setFilteredData(updatedData);
  };

  return (
    <div>
      <div className={`${styles.ExecutiveBox} p-20`}>
        <div className={`${styles.TextBox}`}>
          <div className={`${styles.ExecutiveIcon} csicon`} />
          <div className={`${styles.ChatText} font14 fw500 color111`}>Please search your query below.</div>
        </div>
      </div>
      <div className={`${styles.SeachBox} p-20`}>
        <div className={`${styles.SeachGroup} `}>
          <div className={`${styles.SeachIcon} csicon`} />
          <input
            value={searchInput}
            onChange={(e) => handleSearchInput(e.target.value)}
            className={`${styles.SeachInput} font12 fw400 color111`}
            type="text"
            placeholder="Search your query here."
          />
          {searchInput && (
            <div
              aria-label="others_search_input_cancel"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              onClick={() => setSearchInput('')}
              className={`${styles.SeachClear} csicon`}
            />
          )}

          <div className={`${styles.SeachDropDown} ${searchInput ? '' : 'dn'}`}>
            <div className={`${styles.SeachResult}`}>
              <ul className={`${styles.ResultList}`}>
                {filteredData?.length > 0 ? (
                  filteredData.some(
                    (issueData) => issueData.filteredDispObj && Object.keys(issueData.filteredDispObj).length > 0,
                  ) ? (
                    filteredData.map((issue, issueIdx) => (
                      <div key={issueIdx} className="mt-10">
                        {issue.filteredDispObj && Object.keys(issue.filteredDispObj).length > 0 && (
                          <>
                            <div className="font10 fw500 color333">{issue.issue_type}</div>
                            <div>
                              {Object.entries(issue.filteredDispObj).map(([key, value], idx) => (
                                <li key={idx}>
                                  <div
                                    className={`${styles.ResultItem}`}
                                    tabIndex={0}
                                    role="button"
                                    onKeyDown={() => {}}
                                    onClick={async () => {
                                      await clickTracker(`Update_${value?.trim()}`, 'Raiseaticket');
                                      setSelectedSubIssue(key?.trim());
                                      setFinalIssuesObj({ issue: issue.issue_type, subIssue: value?.trim() });
                                    }}
                                  >
                                    <div className={`${styles.ResultTxt}`}>
                                      <div className="font13 fw500 color111">{key}</div>
                                    </div>
                                    <div className={`${styles.ChevronRgt} csicon`} />
                                  </div>
                                </li>
                              ))}
                            </div>
                          </>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="font13 fw500 color111 text-center">No data</div>
                  )
                ) : (
                  <div className="font13 fw500 color111 text-center">No data</div>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OthersIsuue;

OthersIsuue.propTypes = {
  allIssuesArr: PropTypes.array,
  setSelectedSubIssue: PropTypes.func,
  setFinalIssuesObj: PropTypes.func,
};
